import lfRequest from '@/service/index'
export function etfExport(file:any,type:any) {
  return lfRequest.post<any>({
    url: '/main/crawler/export/etf',
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    responseType: type
  })
}
